<template lang='pug'>
    v-content
      v-container(fluid)
        v-flex
          v-card
            v-toolbar(card color='white')
              v-toolbar-title Whatsapp Number Registration
            v-divider
            v-card-text(class='pa-0')
              v-container(fluid)
                v-alert(v-model="successAlert" dismissible type="success") Update successfully.
                v-alert(v-model="emptyPhoneAlert" dismissible type="error") Phone field can't be empty!!!
                v-alert(v-model="errorAlert" dismissible type="error") Update data is failed!!!
                v-alert(v-model="numberAlert" dismissible type="error") 
                  | Please entry valid number, use 
                  b +62 
                  | at the beginning of your phone number, and 
                  b do not use space or hyphen (dash) 
                  | in the middle of number.
                v-alert(v-model="unAuthorizedAlert" type="error") {{message}}
                form(v-if="!unAuthorizedAlert")
                  v-text-field(
                    v-model="phone"
                    label="Phone/Whatsapp Numbers"
                    placeholder="+62..."
                    hint="Use comma if more than one number. e.g. +6281234567,+6283214567, ..."
                    persistent-hint)
                  v-checkbox(
                    v-model="checkbox"
                    label="Receive Whatsapp Notification for Approval")
                  v-btn(color="primary" @click="submit") Save
                  v-btn(color="success" @click="clear") Clear
</template>
<script>
import * as i18n from "../data/i18n.json";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "RegWaNumberWithoutLogin",
  components: {
  },
  data() {
    return {
      i18n: i18n.default,
      user: {},
      phone: '',
      checkbox: false,
      successAlert: false,
      errorAlert:false,
      emptyPhoneAlert:false,
      unAuthorizedAlert:false,
      message: '',
      numberAlert: false
    };
  },
  async mounted() {
    const p = this.$route.params;
    const config = {
        method: "get",
        url: `${this.API_URL}/api/authorize-user/${p.token}`
      };
    axios(config).then(res => {
      if (res.data.status) {
        this.user = res.data.dataUser;
        this.phone = this.user.phone;
        this.checkbox = this.user.waNotif ? true : false;
      } else {
        this.unAuthorizedAlert = true;
        this.message = res.data.message;  
      }
    }).catch(err => {
      this.unAuthorizedAlert = true;
      this.message = err;  
    });
  },
  computed: {
    ...mapState(["API_URL"]),
  },
  methods: {
    submit() {
      if (this.checkbox && this.phone.length == 0) {
        this.emptyPhoneAlert = true;
        this.successAlert = false;
        this.errorAlert = false;
        this.numberAlert = false;
      } else if (!this.checkbox && this.phone.length == 0) {
        const config = {
          method: "put",
          url: `${this.API_URL}/api/wa-number`,
          data: {
            id:this.user.id,
            phone:this.phone,
            waNotif:(this.checkbox ? 1 : 0)
          }
        };
        axios(config).then(res => {
          this.emptyPhoneAlert = false;
          this.numberAlert = false;
          if (res.data.id == this.user.id) this.successAlert = true;
          else this.errorAlert = true;
        }).catch(err => {
          // console.log(err);
          this.emptyPhoneAlert = false;
          this.errorAlert = true;
          this.numberAlert = false;
        });        
      } else {
        let newPhone = this.phone.split(',');
        let valid = true;
        for (let item of newPhone) {
          item = item.trim()
          if(/^(\+62)[0-9]{7,14}$/.test(item) == false){
            valid = false;
            break;
          }
        }
        if(!valid){
          this.successAlert = false;
          this.numberAlert = true;
        }else{
          this.numberAlert = false;
          const config = {
            method: "put",
            url: `${this.API_URL}/api/wa-number`,
            data: {
              id:this.user.id,
              phone:this.phone,
              waNotif:(this.checkbox ? 1 : 0)
            }
          };
          axios(config).then(res => {
            this.emptyPhoneAlert = false;
            if (res.data.id == this.user.id) this.successAlert = true;
            else this.errorAlert = true;
          }).catch(err => {
            // console.log(err);
            this.emptyPhoneAlert = false;
            this.errorAlert = true;
          });
        }
      }
    },
    clear() {
      this.phone = '';
      this.checkbox = false
    }
  }
};
</script>
